import type { CopilotThemeOptions } from "owa-copilot-themes-types";
import { getStore } from "../store/store";

export default function getCopilotThemeOptions(): CopilotThemeOptions {
    return getStore().options;
}
